// placeholderDatasetPlugin.js

export const placeholderDatasetPlugin = {
    id: 'placeholderDataset',
    beforeUpdate(chart, args, options) {
        const { datasets = [] } = chart.data;

        if (datasets.length === 0) {
            insertPlaceholder(chart, options);
            return;
        }

        let totalDataPoints = 0;

        for (const ds of datasets) {
            if (!Array.isArray(ds.data) || ds.data.length === 0) {
                continue;
            }

            const sum = ds.data.reduce((acc, val) => acc + (val || 0), 0);
            totalDataPoints += sum;
        }

        if (totalDataPoints === 0) {
            insertPlaceholder(chart, options);
        }
    }
};

const insertPlaceholder = (chart, options) => {
    chart.data.labels = options.labels ?? ['No data'];

    chart.data.datasets = [
        {
            label: options.label ?? 'No data',
            data: options.data ?? [1],
            backgroundColor: options.backgroundColor ?? ['#ccc'],
            hoverBackgroundColor: options.hoverBackgroundColor ?? ['#999']
        }
    ];
}
